import React, { FC, useContext } from "react";
import { Box, Button, Typography } from "@mui/material";
import { NextWindowContext } from "../../../context/NextWindowContext";

interface ArticleComponentProps {
  data: any;
  isFinished?: boolean;
  lastLesson?: boolean;
}
export const ArticleComponent: FC<ArticleComponentProps> = ({
  data,
  isFinished,
  lastLesson,
}) => {
  const nextWindow = useContext(NextWindowContext);
  return (
    <Box
      sx={{
        width: "100%",
      }}>
      <Box
        sx={{
          minHeight: "478px",
          border: "1px solid rgba(1, 18, 36, 0.12)",
          display: "flex",
          padding: "32px",
          flexDirection: "column",
        }}>
        <Typography
          sx={{
            fontSize: "20px",
            fontWeight: 800,
            marginBottom: "16px",
          }}>
          {data.lecture_name}
        </Typography>

        <Typography
          sx={{
            fontSize: "16px",
            fontWeight: 600,
            marginBottom: "16px",
          }}>
          {data.article}
        </Typography>
      </Box>
      <Box
        sx={{
          display: "flex",
          justifyContent: "flex-end",
          marginTop: "20px",
          padding: "0 20px",
        }}>
        <Button
          className="close-modal-btn"
          variant="contained"
          onClick={() => nextWindow()}>
          {isFinished && lastLesson ? "Завершить прохождение курса" : "Далее"}
        </Button>
      </Box>
    </Box>
  );
};
